import {computed, makeObservable, observable} from "mobx";
import DeliverySiteForm from "../../forms/fields/DeliverySiteForm";

export default class DeliverySiteFeature {

    constructor(application, navigator, deliverySite) {
        this._application = application;
        this._navigator = navigator;
        this._deliverySite = deliverySite;
        this._form = null;
        this._loaded = false;

        makeObservable(this, {
            _loaded: observable,
            loaded: computed,
            _form: observable,
            form: computed,
        });
    }

    async load() {
        this._form = DeliverySiteForm.newFor(this._deliverySite, this);
        this._loaded = true;
    }

    get loaded() {
        return this._loaded;
    }

    get form() {
        return this._form;
    }
}
